import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import IcnNotification from "@assets/icons/rounded/notifications.svg";
import IcnNotificationFill from "@assets/icons/rounded/notifications-fill.svg";
import { IconComponent } from "@app/core";
import { formatMessage } from "@app/translations/intl";

import styles from "./my-deal-alerts-link.module.scss";

export const MyDealAlertsLink = ({ className }: { className?: string }) => {
  return (
    <Link to={formatMessage({ id: "global.dealAlerts.page.url" })} className={clsx(styles.root, className)}>
      {formatMessage({ id: "global.dealAlerts.page.title" })}
      <IconComponent data-icon="notification" icon={IcnNotification} size="20px" />
      <IconComponent data-icon="notification-fill" icon={IcnNotificationFill} size="20px" />
    </Link>
  );
};
